import React from "react";
import { Link } from "react-router-dom";
import _ from "lodash";

import makeStyles from "@mui/styles/makeStyles";
import { Box, Grid, Skeleton, Typography } from "@mui/material";
import ProductCard from "../Product/ProductCard";
import ViewAllButton from "../Common/ViewAllButton";
import useTryNewProducts from "../../Hooks/useTryNewProducts";

const useStyles = makeStyles((theme) => ({
  mainWrapper: {
    display: "flex",
    flexWrap: "nowrap",
    overflowX: "auto",
    overflowY: "hidden",
    WebkitOverflowScrolling: "touch",
    marginTop: theme.spacing(1),
  },
  loaderContent: {},
  loaderWrapper: {
    marginTop: theme.spacing(1),
    marginLeft: theme.spacing(2),
    display: "flex",
    flexWrap: "nowrap",
    overflowX: "auto",
    overflowY: "hidden",
    WebkitOverflowScrolling: "touch",
  },
  viewAllBrandsButtonWrapperLink: {
    textDecoration: "none",
  },
}));

function TryNewProducts(props) {
  const classes = useStyles();
  const { products, loading, error } = useTryNewProducts();

  return (
    <div style={{ margin: "40px 0px 20px 0px" }}>
      {loading === "done" && !error && products && products.length > 0 && (
        <Box
          sx={{
            padding: 2,
            paddingTop: 0,
            background:
              "linear-gradient(180deg, #FFDFDF 1.61%, rgba(255, 223, 223, 0.2) 98.39%)",
            position: "relative",
            "&::before": {
              content: '""',
              position: "absolute",
              top: "-20px",
              left: 0,
              width: "100%",
              height: "20px",
              backgroundColor: "#FFDFDF",
              borderRadius: "50%/20px 20px 0 0",
            },
          }}
        >
          <Grid
            container
            alignItems={"center"}
            justifyContent={"center"}
            sx={{ mb: 0.5 }}
          >
            <Grid item xs={3.5}>
              <Box
                sx={{
                  width: "100%",
                  height: "1.5px",
                  background:
                    "linear-gradient(to left, #9D2123 0%, rgba(157, 33, 35, 0) 100%)",
                  position: "relative",
                  "&::before": {
                    content: '""',
                    position: "absolute",
                    width: "100%",
                    height: "1px",
                    background:
                      "linear-gradient(to left, #9D2123 0%, rgba(157, 33, 35, 0) 100%)",
                    top: 0,
                  },
                }}
              />
            </Grid>
            <Grid item sx={{ padding: "0px 6px" }}>
              <Typography
                sx={{
                  color: "#1C1C1C",
                  fontSize: "14px",
                  textAlign: "center",
                  fontWeight: "700",
                }}
              >
                TRY NEW
              </Typography>
            </Grid>
            <Grid item xs={3.5}>
              <Box
                sx={{
                  width: "100%",
                  height: "1.5px",
                  background:
                    "linear-gradient(to right, #9D2123 0%, rgba(157, 33, 35, 0) 100%)",
                  position: "relative",
                  "&::before": {
                    content: '""',
                    position: "absolute",
                    width: "100%",
                    height: "1px",
                    background:
                      "linear-gradient(to right, #9D2123 0%, rgba(157, 33, 35, 0) 100%)",
                    top: 0,
                  },
                }}
              />
            </Grid>
          </Grid>
          <Typography
            sx={{
              color: "#4F4F4F",
              fontSize: "14px",
              textAlign: "center",
              mb: 1,
            }}
          >
            Try these top picks that you haven't purchased yet
          </Typography>
          <Grid
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="flex-start"
            spacing={2}
          >
            {_.map(
              products.slice(
                0,
                props.numberOfProductsToShow
                  ? props.numberOfProductsToShow
                  : products.length
              ),
              (product, index) => {
                return (
                  <Grid item xs={6} key={index}>
                    <ProductCard
                      product={product}
                      key={product.skuCode}
                      index={index}
                      section={"Try New Products"}
                      stateCode={props.stateCode}
                      newLaunch={false}
                      tryNew={true}
                      saveScrollYPosition={true}
                    />
                  </Grid>
                );
              }
            )}
          </Grid>

          {products && products.length > props.numberOfProductsToShow && (
            <Box sx={{ marginBottom: "20px" }}>
              <Link
                to={`/try-new-products`}
                className={classes.viewAllBrandsButtonWrapperLink}
              >
                <ViewAllButton
                  section={"Try New Products List"}
                  saveScrollYPosition={true}
                />
              </Link>
            </Box>
          )}
        </Box>
      )}

      {loading === "started" && (!error || !error?.data) && (
        <>
          <Skeleton
            variant={`text`}
            width={300}
            style={{ marginLeft: "16px", marginTop: "8px" }}
          />
          <div className={classes.loaderWrapper}>
            <Grid
              container
              direction={`row`}
              justifyContent="flex-start"
              alignItems="flex-start"
              className={classes.loaderContent}
              wrap={"nowrap"}
              spacing={2}
            >
              <Grid item>
                <Skeleton variant={`rectangular`} height={250} width={152} />
              </Grid>
              <Grid item>
                <Skeleton variant={`rectangular`} height={250} width={152} />
              </Grid>
              <Grid item>
                <Skeleton variant={`rectangular`} height={250} width={152} />
              </Grid>
            </Grid>
          </div>
        </>
      )}
    </div>
  );
}

export default TryNewProducts;
